export const shouldRetryQuery = (retryCount, error) => {
    var _a, _b, _c;
    if (!error.response) {
        console.error('React Query retry failure', {
            retryCount,
            code: error.code,
            message: error.message,
            url: (_a = error.config) === null || _a === void 0 ? void 0 : _a.url,
            baseURL: (_b = error.config) === null || _b === void 0 ? void 0 : _b.baseURL,
            hasResponse: false,
        });
    }
    return ((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 401 ? false : retryCount < 2;
};
